import * as React from "react";
import {TextBox, TextBoxProps} from "./TextBox";
import {MaskedInput} from "./MaskedInput";

export interface CreditCardNumberProps
{
	fieldName: string;
	label?: string;
	placeholder?: string;
	value?: string;
	updatedValueCallBack: () => void;
	mask: string;
	shouldTriggerValidation: boolean;
}

export class CreditCardNumber extends React.Component<CreditCardNumberProps, any>
{
	static defaultProps: CreditCardNumberProps =
	{
		fieldName: "ChangeCreditCardFieldName",
		label: "Account Number",
		placeholder: "____ ____ ____ ____",
		updatedValueCallBack: () =>
			{},
		mask: "1111 1111 1111 1111",
		shouldTriggerValidation: false
	};

	render()
	{
		return <TextBox isRequired={this.props
			.shouldTriggerValidation} requiredMessage={"This field is required"} onChange={this.props
				.updatedValueCallBack} {...this.props} mask={this.props.mask}/>;
	}
}


// WEBPACK FOOTER //
// ./src/components/common/CreditCardNumber.tsx